export function getDestinationConfigFlatModel(destination) {
  return {
    id: destination.id,
    type: destination.type,
    ...destination.formData
  };
}
